<template>
  <div class="right_body action_body">
    <span class="btn right_sub_btn save_btn" @click.stop="onSubmitSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">采购订单</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <NewHeaderPanel
        ref="orderHeader"
        :companyList="this.$store.state.cache.companyList"
        :suplierList="this.$store.state.cache.supplierList"
        :headerProps="orderHeader"
      ></NewHeaderPanel>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span>
      </h2>
      <NewDetailPanel
        ref="orderDetail"
        :factoryList="this.$store.state.cache.factoryList"
        :orderMaterial="orderMaterial"
      ></NewDetailPanel>
    </div>

    <div class="coll list_content">
      <h2 class="title">
        <span>项目</span>
      </h2>
      <span style="padding:0 50px 0 0">过量交货限度：</span>
      <input type="text" style="width:50px" value="0.00" />
      <span>%</span>
      <input type="checkbox" style="width:50px;margin-left:20px" />
      <span>无限制</span>
      <br />
      <span style="padding:0 50px 0 0">交货不足限度：</span>
      <input type="text" style="width:50px" value="0.00" />
      <span>%</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NewHeaderPanel from "./components/HeaderBlockNew.vue";
import NewDetailPanel from "./components/DetailBlockNew.vue";
import {
  customerApi,
  matterTypeApi,
  factoryApi,
  fstockApi,
  suplierApi
} from "api/base.js";
import { company } from "api/system.js";
import { purchaseOrderApi } from "api/PurchaseMngApi.js";

export default {
  components: {
    NewHeaderPanel,
    NewDetailPanel
  },
  data() {
    return {
      orderHeader: {
        companyStr: ""
      },
      factoryList: [],
      orderMaterial: null
    };
  },
  //设置校验规则
  vuerify: {},
  computed: {
    errors() {}
  },
  watch: {},
  created() {
    this.loadPurchaseOrder(this.$route.params.id);
    //请求初始数据
    this.initData();
    this.registerEventListener();
  },
  methods: {
    ...mapActions("pages", ["open", "init", "close", "closeOther", "closeAll"]),
    /**
     * 注册事件监听
     */
    registerEventListener(){ 
      //点击tab页 
      this.$bus.on('onClickTabPage', this.onClickTabPage);
      //移除tab页
      this.$bus.on('onRemoveTabPage', this.onRemoveTabPage);
    },
    //移除tab页
    onRemoveTabPage(tabName){
       //this.$route.meta.clearCache=true;
       console.log("onRemoveTabPage clearCache="+this.$route.meta.clearCache);
    },  
    //点击tab页 
    onClickTabPage(tabName){
       //this.$route.meta.clearCache=false;
        console.log(" onClickTabPage clearCache="+this.$route.meta.clearCache);
    },
    async initData() {
      console.log(this.$store.state.cache.factoryList + "工厂-------111");
      //公司列表
      if (!this.$store.state.cache.companyList) {
        let companyList = await this.$post(
          company.list,
          this.$store.state.getAllPage
        );
        console.log(companyList, "========== ");
        if (companyList.status) {
          companyList.data.list.forEach(item => {
            item.value = item.companyCode + "-" + item.companyName;
            item.companyStr = item.companyCode + "-" + item.companyName;
          });
          this.$store.state.cache.companyList = companyList.data.list;
          console.log(this.$store.state.cache.companyList, "====------====");
        } else {
          this.$store.state.cache.companyList = null;
        }
      }

      //供应商
      if (!this.$store.state.cache.supplierList) {
        let suplierList = await this.$post(
          suplierApi.list,
          this.$store.state.getAllPage
        );
        if (suplierList.status) {
          suplierList.data.list.forEach(item => {
            item.value = item.supplierCode + "-" + item.supplierName;
            item.supplierStr = item.supplierCode + "-" + item.supplierName;
          });
          this.$store.state.cache.supplierList = suplierList.data.list;
        } else {
          this.$store.state.cache.supplierList = null;
        }
      }

      //工厂
      if (!this.$store.state.cache.factoryList) {
        // let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
        // if(factoryList.status){
        // 	factoryList.data.list.forEach((item)=>{
        // 		item.display= item.factoryCode+'-' + item.factoryDesc;
        // 	});
        // 	this.$store.state.cache.factoryList = factoryList.data.list;
        // }else{
        // 	this.$store.state.cache.factoryList = null;
        // }
        // let factoryList = await this.$post(factoryApi.factoryFind, {
        //   searchCriteria: { companyId: this.$store.state.cache.PurcOrEditComId }
        // });
        // if (factoryList.status) {
        //   console.log(factoryList);
        //   factoryList.data.list.forEach(item => {
        //     item.factoryDisplay = item.factoryCode + "-" + item.factoryDesc;
        //   });
        //   this.$store.state.cache.factoryList = factoryList.data.list;
        // } else {
        //   this.$store.state.cache.factoryList = null;
        // }
      }
      this.isLoading = false;
    },

     /**
     * 加载采购订单
     */
    async loadPurchaseOrder(purchaseOrderId) {
      if (purchaseOrderId) {
        let result = await this.$get(purchaseOrderApi.loadPurchaseOrderUrl, {
          purchaseOrderId: purchaseOrderId
        });
        this.orderHeader = result.data;
        this.orderHeader.companyStr =
          this.orderHeader.companyCode + "-" + this.orderHeader.companyName;
        this.orderHeader.supplierStr =
          this.orderHeader.supplierCode + "-" + this.orderHeader.supplierDesc;
        this.orderMaterial = result.data.details;
        // Str---------获取工厂信息
        let factoryList = await this.$post(factoryApi.factoryFind, {
          searchCriteria: { companyId: this.orderHeader.companyId }
        });
        if (factoryList.status) {
          factoryList.data.list.forEach(item => {
            item.factoryDisplay = item.factoryCode + "-" + item.factoryDesc;
          });
          this.$store.state.cache.factoryList = factoryList.data.list;
        } else {
          this.$store.state.cache.factoryList = null;
        }
        if (this.orderMaterial) {
          this.orderMaterial.forEach(item => {
            item.factoryDisplay = item.factoryCode + "-" + item.factoryDesc;
          });
        }
      //end 获取工厂信息

      //Start加载公司所有库存地
    
      let inventoryResults = await this.$post(fstockApi.list, {
        searchCriteria: { factoryId: 0 }
      });
      if (inventoryResults.status) {
        this.inventoryList = inventoryResults.data.list;
        this.inventoryList.forEach((item, index) => {
          item.value = item.inventoryDesc;
          item.label = item.inventoryDesc;
          item.key = item.inventoryId;
        });
      } else {
        this.inventoryList = [];
      }
      this.orderMaterial.forEach(item => {
        let list = this.inventoryList.filter(
          p => p.factoryId == item.factoryId
        );
        item.iteminventoryList = list;
      });
      console.log(this.orderMaterial,'新明细数据')
    }
  },
    clearOrder() {
      let vm = this;
      vm.$refs.orderHeader.headerProps = {};
      vm.$refs.orderDetail.orderMaterial = [];
    },
    /**
     * 提交保存
     */
    async onSubmitSave() {
      let isSubmit = true;
      let vm = this,
      order;
      order = vm.$refs.orderHeader.headerProps;
     
      order.details = vm.$refs.orderDetail.orderMaterial;
      order.details.forEach(item => {
        let purchaseNum = parseFloat(item.purchaseNum);
        let inputTax = parseFloat(item.inputTax);
        let netPrice = parseFloat(item.netPrice);
        if (purchaseNum <= 0 || item.purchaseNum === "") {
          this.$message.error("数量必须大于0");
          isSubmit = false;
          return false;
        }
        if (netPrice <= 0 || item.netPrice === "") {
          this.$message.error("采购价格必须大于0");
          isSubmit = false;
          return false;
        }
        if (inputTax < 0 || inputTax >= 100 || item.inputTax === "") {
          this.$message.error("进项税必须为0到100之间小数");
          isSubmit = false;
          return false;
        }
        if (item.inventoryDesc === "" || !item.inventoryDesc) {
        this.$message.error("请选择库存地");
        isSubmit = false;
        return false;
      }
      });
      if (!isSubmit) {
        return;
      }
      //console.log(JSON.stringify(order));
      let res = await this.$post(
        purchaseOrderApi.modifyPurchaseOrderUrl,
        order
      );
      if (res.type == "F") {
        this.$message.error(res.msg);
        return;
      }
      this.$confirm(
        "采购订单号 " +
          res.data.purchaseOrderNo +
          " 修改成功;需要继续创建订单吗？",
        "提示",
        {
          confirmButtonText: "继续",
          cancelButtonText: "退出",
          type: "success"
        }
      )
        .then(() => {
          vm.clearOrder();
          // vm.$router.push({ name: "business-purchaseorder-purchaseordernew" });
          vm.$keepAliveManager.backSourceRoute(this,{name: "business-purchaseorder-purchaseordernew"});
        })
        .catch(() => {
          vm.$router.push({
            name: "business-purchaseorder-purchaseordersearch"
          });
          vm.clearOrder();
          vm.close("business-purchaseorder-purchaseordernew");
        });

      // alert(JSON.stringify(order));
    }
  }
};
</script>

<style lang="stylus" scoped></style>